@let latestSmwDataValue = latestSmwData();
@let greenTableDesignValue = smwService.greenTableDesign();

<div class="station-card__header">
  @let stationValue = station();
  <mat-card-title class="station-card-title-text">
    {{ stationValue.overwriteStationName }}
  </mat-card-title>

  <div class="station-card__spacer"></div>

  <mat-card-subtitle class="station-card-subtitle-text">
    <fa-icon
      [icon]="stationValue | stationIconCard"
      class="header-status-icon"></fa-icon>
    &nbsp;
    <span>
      {{
        latestSmwDataValue['dtg']
          | datex: 'dd DD.MM. HH:mm' : undefined : languageService.langSignal()
      }}
    </span>
  </mat-card-subtitle>
</div>

<!-- 2. MEDIEN-BEREICH (Webcam oder Standard-Stationsbild mit Zoom-Klasse) -->
@let webcamImageValue = webcamImage();
<div class="station-card-image-wrapper">
  @if (webcamImageValue) {
    <img
      mat-card-image
      [src]="webcamImageValue"
      alt="Webcam"
      class="zoom clickable-webcam"
      (click)="onWebcamClick()" />
  } @else {
    <img
      mat-card-image
      [src]="stationImage()"
      alt="Station image"
      class="station-fallback-image" />
  }
</div>

@if ((latestSmwDataValue | key).length) {
  @let parameterGroupsValue = parameterGroups();

  <table class="station-card__table">
    @for (parameterGroup of parameterGroupsValue | key; track $index) {
      <!-- Filter-Logik: Falls TT geladen, RRR ausblenden, um Überlaufen der Karte zu verhindern -->
      @if (
        !(
          (latestSmwDataValue.hasOwnProperty('tt') ||
            latestSmwDataValue.hasOwnProperty('road_tt')) &&
          parameterGroup === 'rrr'
        ) && parameterGroupsValue.hasOwnProperty(parameterGroup)
      ) {
        <tr class="station-card-table-row">
          <!-- Parameter-Icon (Zellendesign) -->
          <td
            class="station-card__icon"
            [matTooltip]="
              'PRODUCT.SMW.TABLE_PARAMETERS.' + parameterGroup | translate
            ">
            <ng-container
              appWmIcon
              [inputParameter]="parameterGroup"></ng-container>
          </td>

          <!-- Schleife durch die Unter-Parameter der Gruppe -->
          @for (
            parameter of parameterGroupsValue[parameterGroup];
            track $index;
            let i = $index
          ) {
            @switch (parameter) {
              <!-- Fall 1: Temperaturen (Luft / Straße) -->
              @case (
                parameter === 'tt' || parameter === 'road_tt' ? parameter : ''
              ) {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right"
                  [ngClass]="
                    latestSmwDataValue[parameter]
                      | colorMappingTT: greenTableDesignValue
                  ">
                  <span class="value-number">{{
                    latestSmwDataValue[parameter] | number: '1.1-1'
                  }}</span>
                  <span class="station-card-unit">°C</span>
                </td>
              }

              <!-- Fall 2: Straßenzustand (Zustandstexte aus DB) -->
              @case ('road_condition') {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right"
                  [ngClass]="
                    latestSmwDataValue[parameter]
                      | colorMappingCond: greenTableDesignValue
                  "
                  [matTooltip]="
                    'MAPPING.GMA_ROAD_CONDITION.' +
                      latestSmwDataValue[parameter] | translate
                  ">
                  <span class="condition-badge-text">
                    {{
                      'MAPPING.GMA_ROAD_CONDITION_SHORT.' +
                        latestSmwDataValue[parameter] | translate
                    }}
                  </span>
                </td>
              }

              <!-- Fall 3: Windrichtung (Rotierendes Pfeil-Icon) -->
              @case ('dd') {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-center"
                  [matTooltip]="
                    latestSmwDataValue[parameter] | windrose | translate
                  ">
                  <div
                    class="wind-direction-arrow"
                    [ngStyle]="{
                      transform:
                        'rotate(' + latestSmwDataValue[parameter] + 'deg)',
                    }">
                    <ng-container
                      appWmIcon
                      [inputParameter]="'long-arrow-down'"></ng-container>
                  </div>
                </td>
              }

              <!-- Fall 4: Windgeschwindigkeit -->
              @case ('ff') {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right">
                  <span class="value-number">{{
                    latestSmwDataValue[parameter] | round
                  }}</span>
                  <span class="station-card-unit"> km/h</span>
                </td>
              }

              <!-- Fall 5: Relative Luftfeuchtigkeit -->
              @case ('rh') {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right">
                  <span class="value-number">{{
                    latestSmwDataValue[parameter] | number: '1.0-1'
                  }}</span>
                  <span class="station-card-unit">%</span>
                </td>
              }

              <!-- Fall 6: Niederschlag -->
              @case ('rrr') {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right">
                  <span class="value-number">{{
                    latestSmwDataValue[parameter]
                  }}</span>
                  <span class="station-card-unit"> mm</span>
                </td>
              }

              <!-- Fall 7: GMA Alarm-Status (Farbliche Zuweisung über Service) -->
              @case ('gmaAlarm') {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right alarm-status-cell"
                  [ngStyle]="{
                    backgroundColor:
                      smwService.gmaAlarmColors[latestSmwDataValue['gmaAlarm']],
                  }">
                  <span class="alarm-badge-text">
                    {{
                      'PRODUCT.SMW.Alarm.' +
                        smwService.gmaAlarmText[latestSmwDataValue['gmaAlarm']]
                        | translate
                    }}
                  </span>
                </td>
              }

              <!-- Standard-Fallback: Temperatur-Formatierung -->
              @default {
                <td
                  [attr.colspan]="
                    i | colSpan: parameterGroup : parameterGroupsValue
                  "
                  class="value-cell text-right">
                  <span class="value-number">{{
                    latestSmwDataValue[parameter] | number: '1.1-1'
                  }}</span>
                  <span class="station-card-unit">°C</span>
                </td>
              }
            }
          }
        </tr>
      }
    }
  </table>
} @else {
  <!-- 4. LEERZUSTAND (No Data Fallback mit Glassmorphism-Klassen) -->
  <div class="station-card__no-data-container">
    <fa-icon
      [icon]="['far', 'align-slash']"
      size="3x"
      class="no-data-icon"></fa-icon>
    <div class="station-card__no-data-text">
      {{ 'PRODUCT.SMW.NO_DATA_SHORT' | translate }}
    </div>
  </div>
}
